export default "__VITE_ASSET__Bj4JtM4c__"